import { filter, remplazarPorTildeASinTilde } from "../../helpers/Buscador";
import { types } from "../../types/types";

const initialState = {
  items: [],
  itemsAux: [],
  loading: false,
};

export const abmParentescoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.abmTraerTipoParentescosStart:
      return {
        ...state,
        loading: true,
      };
    case types.abmTraerTipoParentescosSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        itemsAux: action.payload
      };
    case types.abmTraerTipoParentescosError:
      return {
        ...state,
        loading: false,
        items: []
      };
    case types.abmBuscarParentescos:
      var itemsResults = state.itemsAux.filter(n => filter(remplazarPorTildeASinTilde(n.descripcionParentesco), remplazarPorTildeASinTilde(action.payload)))
      return {
        ...state,
        items: itemsResults
      };
    default:
      return state;
  }
};
